export default __webpack_public_path__ + "static/media/contact-bg.a0579408.jpg";